import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ActiveZeroState from 'Modules/Actions/components/ZeroStates/Active';
import FailedZeroState from 'Modules/Actions/containers/ZeroStates/Failed';
import { getActiveTab } from 'Modules/Actions/selectors';
import { TABS } from 'Modules/Actions/constants/table';

const CurrentTabZeroState = ({ currentTab }) => {
  switch (currentTab) {
    case TABS.ACTIVE:
      return <ActiveZeroState />;

    case TABS.FAILED:
      return <FailedZeroState />;

    default:
      return <ActiveZeroState />;
  }
};

CurrentTabZeroState.displayName = 'CurrentTabZeroState';
CurrentTabZeroState.propTypes = {
  currentTab: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  currentTab: getActiveTab(state),
});

export default connect(mapStateToProps)(CurrentTabZeroState);
